import React from 'react';
import { modelClass } from '/imports/api/cardSources';
import { ModelFormPage } from '/imports/ui/ModelFormPage';

export const CardSourcePage = () => (
  <ModelFormPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    formSpec={() => [[{ field: 'windowsroot', label: 'Windows Root' }], [{ field: 'clientpath', label: 'Client Path' }]]}
  />
);
